import * as React from "react";
import { Box } from "@mui/system";
import Tab from "@mui/material/Tab";
import classes from "./CustomTabs.module.css";
import { TabContext, TabList, TabPanel } from "@mui/lab";

const CustomTabs = (props) => {
  const [value, setValue] = React.useState(props.initialTab);

  const onTabChange = (event, newTab) => {
    setValue(newTab);
    props.onTabChange(newTab);
  };
  
  React.useEffect(() => {
    // match the received initialTab value from parent
    // after the first render
    setValue(props.initialTab);
  }, [props.initialTab]);

  // if selected tab doesnt exist on tabs list, reset tab to initialTab
  if (!props?.tabs?.some(t => t?.label === value)) {
    setValue(props.initialTab);
  }

  return (
    <div className={classes.customTabs}>
      <TabContext value={value}>
        <Box className={props.isHidden ? [classes.box, classes.hidden].join(' ') : classes.box}>
          <TabList
            onChange={onTabChange}
            className={classes.tabsList}
            classes={{
              indicator: classes.indicator,
            }}
          >
            {props.tabs.map((tab) => {
              return (
                <Tab
                  key={tab.value}
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected,
                  }}
                  label={tab.label}
                  value={tab.label}
                />
              );
            })}
          </TabList>
        </Box>
        {props.tabs.map((tab) => {
          return (
            <TabPanel sx={props?.panelSx} classes={{root: props?.isOverflowNeeded ? [classes.panel, classes.overflow].join(' ') : classes.panel}} key={tab.value} value={tab.label}>
              {tab.data}
            </TabPanel>
          );
        })}
      </TabContext>
    </div>
  );
};

export default CustomTabs;
